export enum NotificationFilterTypeEnum {
    CLIENT = 'Cliente',
    CLIENT_CLASSIFICATION = 'Classificação'
}

export type NotificationFilterType = keyof typeof NotificationFilterTypeEnum;
